import { Component, OnInit, ElementRef } from '@angular/core';

import { ControlValidatorService } from '../../services/control-validator.service';

import { LabelViewModel } from '../../types/control.types';
import { AbstractValueControlBase } from '../../types/abstract-value-control-base';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dy-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.css']
})
export class LabelComponent extends AbstractValueControlBase<LabelViewModel> implements OnInit {
  type: string = 'Label';
  isDesign: boolean = false;
  model: LabelViewModel;

  constructor(protected element: ElementRef) {
    super();
  }

  ngOnInit() {
    if (this.hidden === undefined) {
      this.hidden = this.model.isHidden;
    }
  }

  bindEvents(): void {
    this.valueElement = this.getChildrenByPosition(this.element.nativeElement, 0, 0);
    this.bindEventsToEl(this.valueElement);
  }
}
